import { SETTING_TYPE } from "@/constants/enum";
import { Setting } from "@/types/components/metafield";

  export const getEnableMethods = (settings?: Setting[]) => {
    if (settings) {
      const isEnablePickup = settings.some((s) => s.type === SETTING_TYPE.PICKUP && s.location?.isEnablePickup);

      const isEnableDelivery = settings.some(
        (s) => s.type === SETTING_TYPE.DELIVERY && s.location?.isEnableDelivery && s.isActive,
      );

      const isEnableShipping = settings.some((s) => s.type === SETTING_TYPE.SHIPPING && s.isActive);

      return { isEnablePickup, isEnableDelivery, isEnableShipping };
    }
  };